<template>
    <div class="accordion-item">
        <div class="accordion-header">
            <a :class="{ collapsed: !show }" class="accordion-button gap-2 text-dark fs-6 py-3" role="button" @click="toggle">
                <i v-if="icon" :class="icon" class="fs-4 text-primary" />
                {{ header }}
            </a>
        </div>
        <div :class="{ show: show }" class="accordion-show collapse">
            <div class="accordion-body">
                <div class="rich-text" v-html="$prismic.asHtml(text)" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        header: {
            type: String,
            required: true
        },
        text: {
            type: Array,
            required: true
        },
        icon: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        toggle() {
            this.show = ! this.show;
        }
    }
};
</script>